import { DataTypes } from '@lexriver/data-types'
import { JsonMap } from "@lexriver/json-map"
import { StringMethods } from "@lexriver/string-methods"
import { TypeEvent } from '@lexriver/type-event'
import { debounce } from "ts-debounce"
import { Ecom } from '../Ecom/Ecom'
import { FacebookPixel } from '../FacebookPixel'
import { GlobalBasket } from "../GlobalBasket"
import { GlobalUser } from "../GlobalUser"
import { JsonBasket } from "../json-data-types/JsonBasket"
import { JsonBasketProductInfo } from "../json-data-types/JsonBasketProductInfo"
import { JsonBasketRow } from '../json-data-types/JsonBasketRow'
import { JsonBasketStats } from "../json-data-types/JsonBasketStats"
import { JsonCoupon } from '../json-data-types/JsonCoupon'
import { JsonOrderItem } from '../json-data-types/JsonOrderItem'
import { JsonProduct } from '../json-data-types/JsonProduct'
import { EnumWebsocketPushMessages, RequestMaker } from '../server-queries/RequestMaker'
import { ServerCoupons } from '../server-queries/ServerCoupons'
import { ServerProducts } from '../server-queries/ServerProducts'
import { ChosenAttributes, IBasket } from "./IBasket"

const filename = 'BasketOnServer'

export class BasketOnServer implements IBasket {
    static countOfInstances = 0
    protected quantityByProductInfo = new JsonMap<JsonBasketProductInfo, number>()
    protected couponCodes:string[] = []
    public onChangeEvent: TypeEvent<() => void> = new TypeEvent()
    public onBasketEmptyOrNotEvent: TypeEvent<(isEmpty: boolean) => void> = new TypeEvent()
    public onCouponChangeEvent:TypeEvent<()=>void> = new TypeEvent()
    public onBasketStatsEvent: TypeEvent<(basketStats:any)=>void> = new TypeEvent()
    protected prevIsEmpty: boolean = true
    protected _isInitialized: boolean = false
    
    constructor() {
        BasketOnServer.countOfInstances++

        this.subscribeToTriggerBasketEmptyOrNotEvent()
        this.subscribeToPushMessages()
        this.subscribeToUserChangeEvent()

        // setTimeout(() => {
            this.initAsyncDebounced()
        // }, 2000)
        
    }

    protected subscribeToUserChangeEvent(){
        // GlobalUser.eventUserLoggedIn.subscribe((user) => {
        //     this.initAsync()
        // })

        GlobalUser.eventUserLoggedOut.subscribe(async () => {
            await this.onChangeEvent.triggerAsync()
        })
        GlobalUser.eventUserLoggedIn.subscribe((user) => {
            this.initAsyncDebounced()
        })
        GlobalUser.loggedInUserO.eventOnChange.subscribe(() => {
            this.initAsyncDebounced()
        })


    }

    /**
     * Basket empty or not event
     */
    protected subscribeToTriggerBasketEmptyOrNotEvent(){
        this.onChangeEvent.subscribe(async () => {
            // console.log('BasketOnServer', 'onChangeEvent!')
            //console.log('Basket.ts onChangeEvent')
            const isEmptyNow = this.quantityByProductInfo.size == 0
            //console.log('prevIsEmpty=', this.prevIsEmpty, 'isEmptyNow=', isEmptyNow)
            if (this.prevIsEmpty !== isEmptyNow) {
                //console.log('Basket.ts triggering onBasketEmptyOrNotEvent')
                await this.onBasketEmptyOrNotEvent.triggerAsync(isEmptyNow)
                this.prevIsEmpty = isEmptyNow
            }
        })
    }

    /**
     * Subscribe to change internal products and quantity by push message
     */
    protected subscribeToPushMessages(){
        // on quantity update event:
        RequestMaker.subscribeToPushMessage(EnumWebsocketPushMessages.BasketQuantityUpdate, async (params:any) => {
            //console.log('BasketOnServer on push message', EnumWebsocketPushMessages.BasketQuantityUpdate, params)
            // check params
            if(params.productInfo && DataTypes.isNumber(params.quantity) && params.quantity>=0 && params.hash && params.quantity>=0){
                // ok
            } else {
                console.error('wrong params for '+EnumWebsocketPushMessages.BasketQuantityUpdate, params)
                return
            }

            // params = {productInfo,quantity:newQuantity, hash:this.getHash()}

            if(params.quantity == 0){
                this.quantityByProductInfo.delete(params.productInfo)
            } else {
                this.quantityByProductInfo.set(params.productInfo, params.quantity)
            }
            void this.onChangeEvent.triggerAsync()
            
            if(this.getHash() !== params.hash){
                console.warn('basket hash is not the same, so query full basket', this.getHash(), params.hash)
                this.initAsyncDebounced()
            }
        })

        RequestMaker.subscribeToPushMessage(EnumWebsocketPushMessages.BasketStats, async (params:any) => {
            // console.log('******** basket-stats', params)
            await this.onBasketStatsEvent.triggerAsync(params)
            // console.log('this.onBasketStatsEvent countOfSubscribers=', this.onBasketStatsEvent.countOfSubscribers)
            
        })


        // on clear event
        RequestMaker.subscribeToPushMessage(EnumWebsocketPushMessages.BasketClear, async (params:any) => {
            this.quantityByProductInfo.clear()
            this.couponCodes = []
            await this.onChangeEvent.triggerAsync()
        })

        RequestMaker.subscribeToPushMessage(EnumWebsocketPushMessages.BasketCouponsUpdate, async () => {
            this.initAsyncDebounced()
            await this.onChangeEvent.triggerAsync()
        })






    }

    getWarningMessageOnRemovingObsoleteProducts(countOfProducts:number){
        return StringMethods.formatPluralNumber({
            number: countOfProducts,
            settings: {
                locale: 'ru',
                ifZero:(x)=>null,
                ifOne:(x)=>`Из корзины был удален 1 товар, так как его больше нет в наличии`,
                ifFew:(x)=>`Из корзины было удалено ${x} товара, так как их больше нет в наличии`,
                ifMany:(x)=>`Из корзины было удалено ${x} товаров, так как их больше нет в наличии`
            }
        })
    }


    protected initAsyncDebounced = debounce(this.initAsync, 500)
    protected async initAsync(){
        //console.log('BasketOnServer: initAsync()')
        if(await GlobalUser.checkIfLoggedInAsync() === false) {
            // skip if user is not logged in
            //return
        } else {
            //console.log('---> sessionId=', GlobalUser.sessionIdO.get())
            const {basket, obsoleteProductsRemovedCount} = await RequestMaker.sendWebsocketJsonRequestAsync({query:'basket-pack'}, this) as {basket:JsonBasket, obsoleteProductsRemovedCount:number}

            // console.log('BasketOnServer:', 'basket=', basket, 'obsoleteProductsRemovedCount=', obsoleteProductsRemovedCount)
            if(obsoleteProductsRemovedCount>0){
                alert(this.getWarningMessageOnRemovingObsoleteProducts(obsoleteProductsRemovedCount))
            }
            if(basket){
                this.quantityByProductInfo.initFromArray(basket.items)
                this.couponCodes = basket.couponCodes as string[]
                // console.log('BasketOnServer', 'initAsync', 'triggering basket eventonChange')
            }

            await this.mergeFromAnonymousBasketAsync()

        }

        await this.onChangeEvent.triggerAsync()

        //#region update internal basket quantity by push-messages only
        //console.log('BasketOnServer subscribeToPushMessage BasketQuantityUpdate')
        //#endregion

        this._isInitialized = true
        //console.log('BasketOnServer: initAsync()', 'this._isInitialized=', this._isInitialized, 'loggedInUser=', GlobalCurrentUser.loggedInUserO.get())
    }

    protected async mergeFromAnonymousBasketAsync(){
        const anonymousProducts = await GlobalBasket.anonymousBasket.getListOfRowsAsync()
        if(anonymousProducts.length>0){
            for(let row of anonymousProducts){
                await this.addAsync(row.product, row.quantity, row.productChosenAttributes)
            }
            //console.log('((', 'added from anonymous basket', anonymousProducts.length)
            await GlobalBasket.anonymousBasket.clearAsync()
        }
    }


    async addAsync(product:JsonProduct, quantity: number, chosenAttributes?:ChosenAttributes) {
        try {
            const productInfo:JsonBasketProductInfo = {
                productId: product.id,
                chosenAttributes
            }
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'basket-add-product', params:{
                productInfo,
                quantity
            }}, this)
            //this.onChangeEvent.triggerAsync() // no need for this event, just wait for push message
            void Ecom.addProductToBasketAsync(product, quantity, productInfo.chosenAttributes)
            void FacebookPixel.addProductToBasketAsync(product, quantity, productInfo.chosenAttributes)

            return true
        } catch(x){
            console.error('BasketOnServer addAsync failed', x)
        }
        return false
    }

    async changeQuantityAsync(product:JsonProduct, quantity: number, chosenAttributes?:ChosenAttributes) {
        try{
            const productInfo:JsonBasketProductInfo = {
                productId: product.id,
                chosenAttributes
            }
            const currentQuantity = this.getQuantity(product, chosenAttributes)
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'basket-change-quantity', params:{productInfo, quantity}}, this)
            //this.onChangeEvent.triggerAsync() // no need for this event, just wait for push message
            if (quantity > currentQuantity) {
                void Ecom.addProductToBasketAsync(product, quantity-currentQuantity, productInfo.chosenAttributes)
                void FacebookPixel.addProductToBasketAsync(product, quantity, productInfo.chosenAttributes)

            } else if (quantity < currentQuantity) {
                void Ecom.removeProductFromBasketAsync(product, currentQuantity-quantity, )

            }
            return true
        } catch(x){
            console.error('BasketOnServer changeQuantityAsync failed', x)
        }
        return false
    }

    /**
     * get quantity by productInfo or return 0
     * @param productInfo
     */
    getQuantity(product:JsonProduct, chosenAttributes?:ChosenAttributes): number {
        //const key = this.getStringKeyFromProductInfo(productInfo)
        const productInfo:JsonBasketProductInfo = {
            productId: product.id,
        }
        if(chosenAttributes){
            productInfo.chosenAttributes = chosenAttributes
        }
        const result = this.quantityByProductInfo.get(productInfo) || 0
        // console.log('BasketOnServer.getQuantity', product.id, chosenAttributes, 'result=', result, 'quantityByProductInfo=', this.quantityByProductInfo.toJsonString())
        return result
    }

    getQuantityByProductId(productId: number): number {
        let result = 0
        for (let [k, v] of this.quantityByProductInfo) {
            if (k.productId == productId) {
                result += v
            }
        }
        return result
    }

    async removeAsync(product:JsonProduct, chosenAttributes?:ChosenAttributes) {
        const productInfo:JsonBasketProductInfo = {
            productId: product.id,
            chosenAttributes
        }
        try {
            const currentQuantity = this.getQuantity(product, chosenAttributes)
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'basket-change-quantity', params:{productInfo, quantity:0}}, this)
            void Ecom.removeProductFromBasketAsync(product, currentQuantity, productInfo.chosenAttributes)
            //this.onChangeEvent.triggerAsync()
            return true
        } catch(x){
            console.error('BasketOnServer removeAsync failed', x)
        }
        return false

    }

    protected productsToRemove:JsonMap<JsonBasketProductInfo, JsonProduct> = new JsonMap<JsonBasketProductInfo, JsonProduct>()
    markProductToRemove(product:JsonProduct, chosenAttributes?:ChosenAttributes){
        const productInfo:JsonBasketProductInfo = {
            productId: product.id,
            chosenAttributes
        }
        this.productsToRemove.set(productInfo, product)
    }

    unmarkProductToRemove(product:JsonProduct, chosenAttributes?:ChosenAttributes){
        const productInfo:JsonBasketProductInfo = {
            productId: product.id,
            chosenAttributes
        }
        this.productsToRemove.delete(productInfo)
    }

    unmarkAllProducts(){
        this.productsToRemove.clear()
    }

    checkIfProductIsMarkedToRemove(product:JsonProduct, chosenAttributes?:ChosenAttributes):boolean{
        const productInfo:JsonBasketProductInfo = {
            productId: product.id,
            chosenAttributes
        }
        // console.log('checkIfProductIsMarkedToRemove', product, chosenAttributes, this.productsToRemove.has(productInfo))
        return this.productsToRemove.has(productInfo)
    }



    async removeMarkedProductsAsync():Promise<void>{
        await this.notifyEcomOfRemovingMarkedProductsAsync()

        const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'basket-remove-few', params:{
            productInfoArray: Array.from(this.productsToRemove.keys()), 
        }
        }, this)
        console.log('basket-remove-few response=', response)
        // for(let [basketProductInfo, product] of this.productsToRemove){
            // await this.removeAsync(product, basketProductInfo.chosenAttributes)
        // }
        this.productsToRemove.clear()
    }

    async notifyEcomOfRemovingAllProductsFromBasketAsync(){
        await this.iterateProductsAsync(async (productInfo, quantity, product) => {
            void Ecom.removeProductFromBasketAsync(product, quantity, productInfo.chosenAttributes)
        })
    }

    async notifyEcomOfRemovingMarkedProductsAsync(){
        for(let [basketProductInfo, product] of this.productsToRemove){
            const currentQuantity = this.getQuantity(product, basketProductInfo.chosenAttributes)
            void Ecom.removeProductFromBasketAsync(product, currentQuantity, basketProductInfo.chosenAttributes)
        }
    }

    // async iterateProductsAsync(action:(productInfo:JsonBasketProductInfo, quantity:number, product:JsonProduct) => Promise<void>|void){
    //     let productById = await ServerProducts.getProductsByIdsAsObjectAsync(this.getProductIds())
    //     if(Object.values(productById).length == 0) return
    //     for(let [productInfo,quantity] of this.quantityByProductInfo.toArray()){
    //         // let productInfo: JsonBasketProductInfo = JSON.parse(k) as JsonBasketProductInfo
    //         // let quantity = v1
    //         let product = productById[productInfo.productId]

    //         if (!product) {
    //             console.error('unable to get product by id', productInfo.productId)
    //         } else {  
    //             await action(productInfo, quantity, product)
    //         }

    //     }
    // }

    async iterateProductsAsync(action:(productInfo:JsonBasketProductInfo, quantity:number, product:JsonProduct) => Promise<void>|void){
        // let productById = await ServerProducts.getProductsByIdsAsync(this.getProductIds(), GlobalState.productShowZeroQuantityProductsO.get() ?? false)
        let productById = await ServerProducts.getProductsByIdsAsync(this.getProductIds(), true) // show zero quantity products
        // console.log('productById.length=', Object.keys(productById).length, GlobalState.productShowZeroQuantityProductsO.get() ?? false)
        if(Object.values(productById).length == 0) return
        for(let [productInfo,quantity] of this.quantityByProductInfo.toArray()){
            // let productInfo: JsonBasketProductInfo = JSON.parse(k) as JsonBasketProductInfo
            // let quantity = v
            let product = productById[productInfo.productId]

            if (!product) {
                console.error('unable to get product by id', productInfo.productId)
            } else {
                await action(productInfo, quantity, product)
            }

        }
    }


    async clearAsync() {
        try {
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'basket-clear'}, this)
            // console.log(filename, 'clearAsync response=', response)
            await this.notifyEcomOfRemovingAllProductsFromBasketAsync()
            //this.onChangeEvent.triggerAsync()
            return true
        } catch(x){
            console.error(filename, 'clearAsync()', x)
        }
        return false
    }
    async getStatsAsync(p:{getJsonOrderItems:boolean}): Promise<JsonBasketStats> {
       
        let result:JsonBasketStats = {
            totalQuantity: 0,
            retailSum: 0,
            retailSumDollar: 0,
            wholesaleSum: 0,
            wholesaleSumDollar: 0,
            discountAmountByCouponCode: {},
            discountAmountByCouponCodeInDollar: {},
            skuQuantity: 0,
            giftCertificatesQuantity: 0,
        }

        try {
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'basket-stats'}, this) as JsonBasketStats
            result = response
        } catch(x){
            console.error(x)
        }

        // update couponss if we have some auto-apply couponss on server
        if(result.discountAmountByCouponCode){
            for(const code of Object.keys(result.discountAmountByCouponCode)){
                if(!this.couponCodes.includes(code)){
                    this.couponCodes.push(code)
                }
            }
        }
        
        //const badProducts:JsonBasketProductInfo[] = []
        return result
    }

    toJsonString(): string {
        return this.quantityByProductInfo.toJsonString()
    }

    initFromJsonString(jsonString: string) {
        //const asArray = JSON.parse(jsonString)
        this.quantityByProductInfo.initFromJsonString(jsonString)
    }

    getHash(): number {
        // return StringMethods.getSimpleHash(this.toJsonString())
        return StringMethods.getSimpleHash(JSON.stringify({items: this.quantityByProductInfo.toArray(), couponCodes: this.couponCodes}))

    }

    getProductIds(): number[]{
        let result: number[] = []
        if(this.quantityByProductInfo.size==0) return result
        // console.log('#size=', this.quantityByProductInfo.size)
        for (let [productInfo, quantity] of this.quantityByProductInfo) {
            //let productInfo: JsonBasketProductInfo = JSON.parse(k) as JsonBasketProductInfo
            result.push(productInfo.productId)
        }
        return result
    }


    async getListOfRowsAsync(): Promise<Array<JsonBasketRow>> {
        // let coupons = await this.getListOfCouponsAsync()
        // let basketStats = await this.getStatsAsync({getJsonOrderItems:false})
        // let userType = await GlobalUser.getUserTypeAsync()
        // let canSeeWholesalePrices = await GlobalUser.checkIfCanSeeWholesalePricesAsync()
        
        
        let result: Array<JsonBasketRow> = []

        await this.iterateProductsAsync((productInfo, quantity, product) => {
            let row:JsonBasketRow = {
                product,
                quantity,
                productChosenAttributes: productInfo.chosenAttributes,
                discountByCouponCodeInRub:{}
            }
            result.push(row)

        })

        // sort by product sku
        result.sort((a,b) => a.product.sku.localeCompare(b.product.sku))
        
        return result
    }
    isEmpty() {
        //console.log('@@ this.quantityByProductInfostring=', this.quantityByProductInfoString)
        return this.quantityByProductInfo.size == 0
    }

    isInitialized(){
        return this._isInitialized
    }

    async applyCouponAsync(code:string):Promise<void>{
        try {
            // this will throw if invalid coupon
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'basket-apply-coupon', params:{code:code}}, this)
            await this.onCouponChangeEvent.triggerAsync()

        } catch(x){
            console.error(x)
            // return {error:''+x}
            throw x
        }
    }

    getListOfCouponCodes():string[]{
        return this.couponCodes
    }

    async getListOfCouponsAsync():Promise<JsonCoupon[]>{
        let result :JsonCoupon[] = []
        for(let code of this.couponCodes){
            try {
                let coupon = await ServerCoupons.getAsync(code)
                result.push(coupon)
            } catch(error){
                console.warn('unable to get coupon ', code)
            }
        }
        return result
    }

    getJsonOrderItems():JsonOrderItem[]{
        throw new Error('getJsonOrderItems() not implemented!')
    }

    async removeCouponAsync(code: string): Promise<void> {
        const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'basket-remove-coupon', params:{code}}, this)    
        await this.onCouponChangeEvent.triggerAsync()
    }

}
